const PdfLayoutDefaultInfo = {
    DEFAULT_WIDTH: 50,
    DEFAULT_HEIGHT: 5,
    ITEM_MARGIN: 5,
    DEFAULT_W_1: 2,
    DEFAULT_W_2: 4,
    DEFAULT_W_3: 6,

    SPEC_V: {
        X0: 45,
        X1: 70,
        X2: 160,
        X3: 91.6,
        XR: 130,
        XR0: 40,
        Y0: 95,
        Y1: 40,
        Y2: 60,
        Y3: 85,
        Y4: 120,
        Y5: 140,
        Y6: 160,
        W1: 95,
        W2: 58,
        W3: 65,
        W4: 18,
        W5: 24,
        W_NAME: 25,
        H1: 8,
        H2: 9,
        H4: 9.5,
        H3: 12,
        QR_X: 185,
        QR_X_B: 185,
        QR_Y: 35,
        QR_Y_B: 130,
        POST_CODE_FONT: 19,
        ADDRESS_FONT: 12,
        COMPANY_FONT: 12,
        NAME_FONT: 16,
        POST_CODE_LETTER_SPACE: 9.5,
        ERROR_RECT_1: [
            { x1: 0, x2: 251, y1: 0, y2: 28 },
            { x1: 0, x2: 28, y1: 0, y2: 204 },
            { x1: 0, x2: 251, y1: 176, y2: 204 },
            { x1: 223, x2: 251, y1: 0, y2: 204 },
        ],
    },
    SPEC_Z: {
        X0: 45,
        X1: 70,
        X2: 180,
        X3: 91.6,
        XR: 130,
        XR0: 130,
        Y0: 95,
        Y1: 40,
        Y2: 60,
        Y3: 85,
        Y4: 120,
        Y5: 140,
        Y6: 160,
        W1: 95,
        W2: 58,
        W3: 65,
        W4: 18,
        W_NAME: 25,
        W5: 24,
        H1: 5,
        H2: 8,
        H3: 12,
        H4: 9.5,
        QR_X: 250,
        QR_X_B: 250,
        QR_Y: 95,
        QR_Y_B: 95,
        POST_CODE_FONT: 19,
        COMPANY_FONT: 12,
        NAME_FONT: 16,
        POST_CODE_LETTER_SPACE: 9.5,
        ERROR_RECT_1: [
            { x1: 0, x2: 346, y1: 0, y2: 28 },
            { x1: 0, x2: 28, y1: 0, y2: 203 },
            { x1: 0, x2: 346, y1: 178, y2: 203 },
            { x1: 320, x2: 346, y1: 0, y2: 203 },
        ],
    },
    ADDTIONAL_POSITION_Z_1: ["A", "B", "C"],
    ADDTIONAL_POSITION_Z_2: ["D", "E", "F"],
    ADDTIONAL_POSITION_V_1: ["A", "B"],
    ADDTIONAL_POSITION_V_2: ["C", "D"],
};
export default PdfLayoutDefaultInfo;
